"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.getIllustrationProps = getIllustrationProps;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _utils = require("@react-aria/utils");

function getIllustrationProps(props) {
  let hasLabel = props['aria-label'] || props['aria-labelledby'];
  return (0, _extends2.default)({}, (0, _utils.filterDOMProps)(props, {
    labelable: true
  }), {
    role: hasLabel ? 'img' : undefined,
    'aria-hidden': hasLabel ? undefined : true
  });
}